import React from "react";
import { Link } from "react-router-dom";
import logoImg from "../assets/logo.PNG";

export default function Navbar() {
  return (
    <nav className="sticky top-0 z-50 flex justify-between items-center px-6 py-4 shadow-lg bg-black/95 backdrop-blur-sm">

      {/* Logo */}
      <div className="flex items-center space-x-3">
        <Link to="/" className="flex items-center space-x-2">
          <img
            src={logoImg}
            alt="ACoT Logo"
            className="h-10 w-10"
          />

          <span className="text-2xl font-bold text-lime-400">
            ACoT
          </span>
        </Link>
      </div>


      {/* Menu */}
      <ul className="flex space-x-8 font-medium items-center">

        {/* ================= WHO WE ARE DROPDOWN ================= */}
        <li className="relative group">

          <Link
            to="/about"
            className="flex items-center gap-1 hover:text-lime-400 transition duration-300 py-2"
          >
            Who We Are

            <span className="text-xs transition-transform duration-300 group-hover:rotate-180">
              ▼
            </span>
          </Link>

          <div
            className="
              absolute
              top-full
              left-1/2
              -translate-x-1/2
              mt-3
              w-52
              bg-gray-900
              border
              border-gray-700
              rounded-xl
              shadow-2xl
              opacity-0
              invisible
              translate-y-2
              group-hover:opacity-100
              group-hover:visible
              group-hover:translate-y-0
              transition-all
              duration-300
              overflow-hidden
            "
          >

            <Link
              to="/about"
              className="block px-5 py-3 text-gray-300 hover:bg-lime-400 hover:text-black transition"
            >
              About Us
            </Link>

            <Link
              to="/our-team"
              className="block px-5 py-3 text-gray-300 hover:bg-lime-400 hover:text-black transition"
            >
              Our Team
            </Link>

            <Link
              to="/awards"
              className="block px-5 py-3 text-gray-300 hover:bg-lime-400 hover:text-black transition"
            >
              Awards
            </Link>

            <Link
              to="/reports"
              className="block px-5 py-3 text-gray-300 hover:bg-lime-400 hover:text-black transition"
            >
              Reports
            </Link>

          </div>
        </li>


        {/* ================= OUR WORK ================= */}
        <li>
          <Link
            to="/coming-soon"
            className="hover:text-lime-400 transition duration-300"
          >
            Our Work
          </Link>
        </li>


        {/* ================= NEWS & MEDIA DROPDOWN ================= */}
        <li className="relative group">

          <Link
            to="/news"
            className="flex items-center gap-1 hover:text-lime-400 transition duration-300 py-2"
          >
            News & Media

            <span className="text-xs transition-transform duration-300 group-hover:rotate-180">
              ▼
            </span>
          </Link>


          {/* News & Media Dropdown */}
          <div
            className="
              absolute
              top-full
              left-1/2
              -translate-x-1/2
              mt-3
              w-56
              bg-gray-900
              border
              border-gray-700
              rounded-xl
              shadow-2xl
              opacity-0
              invisible
              translate-y-2
              group-hover:opacity-100
              group-hover:visible
              group-hover:translate-y-0
              transition-all
              duration-300
              overflow-hidden
            "
          >

            {/* News Coverage */}
            <Link
              to="/news-coverage"
              className="
                block
                px-5
                py-3
                text-gray-300
                hover:bg-lime-400
                hover:text-black
                transition
              "
            >
              News Coverage
            </Link>


            {/* Article */}
            <Link
              to="/articles"
              className="
                block
                px-5
                py-3
                text-gray-300
                hover:bg-lime-400
                hover:text-black
                transition
              "
            >
              Article
            </Link>


            {/* Photo Gallery */}
            <Link
              to="/photo-gallery"
              className="
                block
                px-5
                py-3
                text-gray-300
                hover:bg-lime-400
                hover:text-black
                transition
              "
            >
              Photo Gallery
            </Link>

          </div>
        </li>


        {/* ================= SOCIAL MEDIA ================= */}
        <li>
          <Link
            to="/social"
            className="hover:text-lime-400 transition duration-300"
          >
            Social Media
          </Link>
        </li>

      </ul>
    </nav>
  );
}